// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoriesList_container__rkIk8","categories":"CategoriesList_categories__1TDg0","category":"CategoriesList_category__2x5jW"};